export function findLast<T>(
  array: T[],
  callback: (element: T, index: number, array: T[]) => boolean,
): { item: T; index: number } | undefined {
  for (let i = array.length - 1; i >= 0; i--) {
    // 注意：跳过空位（稀疏数组），因为如果数组是稀疏的，当前索引对应的值可能不存在
    if (i in array && callback(array[i], i, array)) {
      return {
        item: array[i],
        index: i,
      };
    }
  }
  return undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isInEnum(value: any, enumObject: any): boolean {
  // 获取枚举的所有值
  const values = Object.values(enumObject);
  // 检查枚举中是否有数字值
  const hasNumber = values.some((v) => typeof v === "number");
  if (hasNumber) {
    // 如果是数字枚举（或者异构枚举，但我们只处理数字部分）
    return values.some((v) => v === value && typeof v === "number");
  } else {
    // 字符串枚举
    return values.includes(value);
  }
}
